<ngx-spinner
  name="initial-auth-check"
  [fullScreen]="true"
  type="ball-atom"
  size="large"
  bdColor="rgba(255, 255, 255, 0.1)"
  color="#1C593D"
>
  <p style="color: #1c593d; font-size: 20px; margin-top: 20px">
    Verificando sesión...
  </p>
</ngx-spinner>
<router-outlet *ngIf="!isCheckingAuth"></router-outlet>
